/**
 * HO-161: adresa události — obec první, pak ulice a číslo popisné.
 *
 * Stejné pravidlo jako BE `AdresaUdalosti.sestav`:
 *  - s ulicí: "OBEC, ULICE ČP" (část obce se vynechá),
 *  - bez ulice: "OBEC - ČÁST ČP", část jen když se liší od obce.
 * Server posílá hotové pole `adresa`; skládání tady je fallback pro starší backend.
 */
export interface AdresaData {
    adresa?: string | null;
    obec?: string | null;
    cast?: string | null;
    ulice?: string | null;
    cisloPopisne?: string | null;
}

const cista = (s?: string | null): string => (s ?? '').replace(/[\s ]+/g, ' ').trim();

/** Část obce je neprázdná a liší se od obce (bez ohledu na velikost písmen). */
export function castJinaNezObec(obec?: string | null, cast?: string | null): boolean {
    const o = cista(obec);
    const c = cista(cast);
    return c !== '' && c.toLocaleLowerCase('cs') !== o.toLocaleLowerCase('cs');
}

export function sestavAdresu(
    obec?: string | null,
    cast?: string | null,
    ulice?: string | null,
    cisloPopisne?: string | null,
): string {
    const o = cista(obec);
    const c = cista(cast);
    const u = cista(ulice);
    const cp = cista(cisloPopisne);

    let hlava: string;
    if (u) {
        hlava = o ? `${o}, ${u}` : u;
    } else {
        hlava = castJinaNezObec(o, c) ? (o ? `${o} - ${c}` : c) : o;
    }
    if (!cp) return hlava;
    return hlava ? `${hlava} ${cp}` : cp;
}

/** Adresa šablony události (pole šablony se jmenují jinak než u události). */
export function adresaSablony(s: {
    obec?: string | null;
    castObce?: string | null;
    ulice?: string | null;
    cisloPopisne?: string | null;
}): string {
    return sestavAdresu(s.obec, s.castObce, s.ulice, s.cisloPopisne);
}

export function formatAdresa(u: AdresaData): string {
    const zeServeru = cista(u.adresa);
    if (zeServeru) return zeServeru;
    return sestavAdresu(u.obec, u.cast, u.ulice, u.cisloPopisne);
}
